import { fulfillmentService } from '@/services';
const makeFulfillmentTable = (fulfillmentList) => fulfillmentList.reduce((acc, it) => Object.assign(acc, {
    [it.user.code]: it,
}), {});
export default {
    /**
     * 사용 안하고 있음. 20241224 윤태건
     * 관제에 사용할 워커 목록
     */
    async getFulfillmentTable({ commit, rootGetters }) {
        const isDistributorUser = rootGetters['user/isDistUser'];
        const distributorId = rootGetters['user/distributorId'];
        const hubId = rootGetters['user/hubId'];
        let data;
        if (isDistributorUser) {
            const result = await fulfillmentService.getFulfillment(distributorId);
            data = result.list;
        }
        else {
            const result = await fulfillmentService.getFulfillment(distributorId, hubId);
            data = result.list;
        }
        const fulfillmentTable = makeFulfillmentTable(data);
        commit('SET_FULFILLMENT_TABLE', fulfillmentTable);
    },
    async updateFulfillment({ commit }, payload) {
        commit('UPDATE_FULFILLMENT', payload);
    },
};
